<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="filterForm.controls.searchTerm"/>
    </div>
    <div class="flex gap-2">
      <elcia-button (onClick)="toggleFilterDisplayed()"
                    [label]="'app.filters' | translate"]
                    [icon]="'filter'"
                    [severity]="isFilterDisplayed() ? 'primary' : 'secondary'"/>
      @if (hasSelectedProducts()) {
        <elcia-button
          (onClick)="showCoefficientDialog()"
          [icon]="'percentage'"
          [label]="'product.apply-coefficient' | translate"
          [severity]="'secondary'"/>
      }
      <elcia-button (onClick)="showForm()" [label]="'action.add-product' | translate" [icon]="'plus'"/>
    </div>
  </div>

  @if (isFilterDisplayed()) {
    <elcia-filter-container>
      <elcia-product-type-dropdown [control]="filterForm.controls.productTypes" [isMulti]="true"/>
    </elcia-filter-container>
  }

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-product-grid
        [(selectedProducts)]="selectedProducts"
        (onDelete)="onProductDelete($event)"
        (productSelected)="onProductSelect($event)"
        [products]="products()"/>
    }
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deleteProduct()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="isEditMode()"
    [size]="'medium'"
    [title]="'entity.product' | translate">

    @if (isLoadingSelectedProduct()) {
      <elcia-loader/>
    } @else {
      <elcia-product-form
        (onSubmit)="submit($event)"
        [initialValue]="store.selectedProduct() ?? undefined"
      />
    }
  </elcia-dialog>
}

@if (isCoefficientDialogDisplayed()) {
  <elcia-dialog
    (onAction)="onCoefficientDialogSave()"
    (onClose)="closeCoefficientDialog()"
    [isActionLoading]="store.applyPriceCoefficientMutation.isPending()"
    [size]="'small'"
    [title]="'product.apply-coefficient' | translate">
    <elcia-price-coefficient-form (onSubmit)="applyCoefficient($event)"/>
  </elcia-dialog>
}
